<template>
    <div class="box-view">
        <template v-if="this.profile.id != -1">
            <div v-if="!this.closed" class="box profile-box">
                <div class="close">
                    <button class="close-button" @click="this.closed = true; this.hasSelectTrinBox = false">X</button>
                </div>

                <p>{{ this.profile.username }} ({{ this.profile.id }})</p>
                <p v-if="getCurrentTrin() != -1">Trin {{ getCurrentTrin() }} / 25</p>
                <button class="profile-box-button open-select-trin-box" :class="{ opened: this.hasSelectTrinBox }" @click="this.hasSelectTrinBox = true">Vælg trin</button>
                <button class="profile-box-button logout" @click="logout">Log ud</button>
            </div>

            <div v-if="this.hasSelectTrinBox" class="box select-trin-box">
                <div class="close">
                    <button class="close-button" @click="this.hasSelectTrinBox = false">X</button>
                </div>

                <div>
                    <button v-if="getCurrentTrin() != -1" @click="select_trin(-1)" class="select-trin hall-of-fame" :key="23">Hall of Fame</button>
                </div>
                <div v-for="i in Array.from({ length: (this.profile.trin == -1 ? 25 : this.profile.trin) }, (v, k) => k + 1)" :key="i">
                    <button v-if="i != getCurrentTrin()" @click="select_trin(i)" class="select-trin">Gå tril trin {{ i }}</button>
                    <button v-else class="select-trin disabled">Ved trin {{ i }}</button>
                </div>
            </div>
        </template>
        <div v-else class="box profile-box">
            <LoginForm />
        </div>
    </div>
</template>

<script>
import LoginForm from "./LoginForm.vue"
import EventBus from "../eventBus.js"

export default {
    name: "ProfileBox",
    props: {
        profile: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            closed: false,
            hasSelectTrinBox: false
        }
    },
    components: {
        LoginForm
    },
    methods: {
        getCurrentTrin() {
            const currentTrin = this.$cookies.get("trin");
            if (currentTrin != null && (this.profile.trin == -1 || this.profile.trin >= currentTrin)) {
                return currentTrin;
            } else {
                return this.profile.trin;
            }
        },

        select_trin(trin) {
            this.$cookies.set("trin", trin);
            EventBus.emit("load-view");
            this.$forceUpdate();
        },

        logout() {
            this.hasSelectTrinBox = false;
            EventBus.emit("logout-profile");
        }
    }
}
</script>

<style scoped>
    .close {
        position: relative;
        left: -50%;
        color: red;
        padding: 6px 6px;
    }

    .close-button {
        background-color: #979696;
        color: red;
        border-radius: 35%;
        font-weight: 750;
        font-size: 16px;
        border: none;
        cursor: pointer;
    }

    .close-button:hover {
        background-color: lightgray;
    }

    .hall-of-fame {
        background-color: gold;
    }

    .hall-of-fame:hover {
        background-color: yellow;
    }

    .select-trin {
        font-size: 15px;
        border-radius: 11px;
        border: none;
        cursor: pointer;
        width: 40%;
        height: 24px;
    }

    .disabled {
        background-color: darkgray;
        pointer-events: none;
    }

    .select-trin:hover:not(.hall-of-fame):not(.disabled) {
        background-color: white; 
    }
    
    .box-view {
        position: absolute;
        top: 10%;
        right: 0rem;
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 2%;
    }

    .box {
        box-sizing: border-box;
        width: 300px; 
        max-width: 90vw;
        padding-inline: 12px;
        background-color: #979696;
        border-radius: 15px;
        border: solid; 
        border-color: darkgray;
        position: relative;
    }

    .select-trin-box {
        padding-bottom: 8px;
    }

    .select-trin-box {
        display: grid;
        gap: 4px;
        margin: 0px;
    }

    .profile-box-button  {
        margin: 8px;
        border-radius: 15px;
        letter-spacing: 1px;
        font-size: 0.9em;
        color: black;
        border: none;
        height: 35px;
        cursor: pointer;
        font-weight: bold
    }
    .logout {
        background-color: red;
    }
    .logout:hover {
        background-color: rgb(250, 70, 70);
    }
    .open-select-trin-box {
        background-color: gold;
    }
    .open-select-trin-box:hover:not(.opened) {
        background-color: yellow;
    }
    .open-select-trin-box.opened {
        pointer-events: none;
    }

    p {
        margin: 0;
        font-size: 20px;
        color: yellow;
    }
</style>
